import { get, post } from "@/utils/api";
import { IS_PREVIEW } from "@/utils/get-service";
import * as previewPaymentService from "./previewPaymentService";
import type {
  PaymentSession,
  CreateSessionInput,
  ConfirmPaymentInput,
  PaymentSessionStatus,
} from "./types";

export const PAYMENT_SESSION_PATH = "/api/payment/session";
export const PAYMENT_CONFIRM_PATH = "/api/payment/confirm";

export async function createPaymentSession(
  input: CreateSessionInput,
  signal?: AbortSignal,
): Promise<PaymentSession> {
  if (IS_PREVIEW) {
    return previewPaymentService.createPaymentSession(input);
  }

  return signal
    ? post<PaymentSession>(PAYMENT_SESSION_PATH, input, signal)
    : post<PaymentSession>(PAYMENT_SESSION_PATH, input);
}

export async function confirmPayment(
  input: ConfirmPaymentInput,
  signal?: AbortSignal,
): Promise<unknown> {
  if (IS_PREVIEW) {
    return previewPaymentService.confirmPayment(input);
  }

  return post(PAYMENT_CONFIRM_PATH, input, signal);
}

export async function getPaymentSessionStatus(
  sessionId: string,
  signal?: AbortSignal,
): Promise<PaymentSessionStatus> {
  return get<PaymentSessionStatus>(
    `/api/payment/session/${encodeURIComponent(sessionId)}/status`,
    signal,
  );
}
